import ContactParamTypes from "./ContactParamTypes"

let params: ContactParamTypes | any = {
    name: null,
    email: null,
    message: null
}

export default params